var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuArrowRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    viewBox: "0 0 19 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.863636 6.36355H16.0514L13.2075 9.20745C12.8702 9.54467 12.8702 10.0915 13.2075 10.4288C13.3761 10.5974 13.5971 10.6817 13.8182 10.6817C14.0392 10.6817 14.2603 10.5974 14.4288 10.4287L18.747 6.11057C19.0843 5.77335 19.0843 5.22649 18.747 4.88921L14.4288 0.571031C14.0916 0.23381 13.5448 0.23381 13.2075 0.571031C12.8702 0.908252 12.8702 1.45511 13.2075 1.79239L16.0514 4.63628H0.863636C0.386679 4.63628 0 5.02296 0 5.49992C0 5.97688 0.386679 6.36355 0.863636 6.36355Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuArrowRight);
export default __webpack_public_path__ + "static/media/menu-arrow-right.8eea96542ac5c624b50aa645464806bb.svg";
export { ForwardRef as ReactComponent };